import React, { Component } from 'react';
import { TryMap, FullCalendarCmp } from '../index'
import '../../css/responsive.css';
class Dashboard extends Component {
    renderRoute = (route, index) => {
        const { GetRoutePoints, OpenDetailsRoute } = this.props
        return (
            <div className="m-2 p-2 border rounded" key={`route-${index}`}>
                <button
                    type="button"
                    className="btn btn-outline-warning float-right mt-1 ml-2"
                    onClick={() => OpenDetailsRoute(route)}>
                    <i className="fa fa-eye mr-2" /> Ver detalles
                </button>
                <div className="rutares" style={{ display:'flex', cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} onClick={() => GetRoutePoints(route)}>
                    <img style={{ maxHeight: "25px", maxWidth: "25px" }} src={require('../../images/ico/routeMap.png')} alt="User" className="rounded mr-2 mt-2" />
                    <div>
                        <span className="text-muted"> {!route.IsActive ? "(Inactivo)" : ""} {route.RouteName} </span> <br/>
                        <span> {route.RouteCode} </span>
                    </div>
                </div>
            </div>
        );
    }

    renderEvent = (event, index) => {
        const { OpenDetailsEvent } = this.props
        return (
            <div className="m-2 p-2 border rounded" key={`event-${index}`}>
                <button
                    type="button"
                    className="btn btn-outline-warning float-right mt-3 ml-2"
                    onClick={() => OpenDetailsEvent(event.id || -1)}>
                    <i className="fa fa-eye mr-2" /> Ver detalles
                </button>
                <div className="rutares" style={{ display:'flex', cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} >
                    <img style={{ maxHeight: "25px", maxWidth: "25px" }} src={require('../../images/ico/routeMap.png')} alt="User" className="rounded mr-2 mt-4" />
                    <div>
                        <span className="h6"> {event.title}<br/>Desde: {event.start} <br/>Hasta: {event.end}</span> 
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { Waypoints, Routes, InitEvents, CalendarFunctions, OpenNewRoute } = this.props
        return (
            <>
                <div className='row'>
                    <div className="col-12 col-md-4 col-lg-3 mb-3">
                        <div className="card h-100" style={{ cursor: "auto"}}>
                            <div className="card-header">
                                <span className="card-title my-0 ruta"> Lista de Rutas </span>
                                <button
                                    type="button"
                                    className="btn btn-outline-success float-right"
                                    onClick={OpenNewRoute}>
                                    <i className="fa fa-plus mr-2" /> Agregar
                                </button>
                            </div>
                            <div className="card-body p-0" style={{ overflow: "auto", maxHeight: 320 }}>
                                {Routes && Routes.map(this.renderRoute)}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-9 mb-3">
                        <div className="card">
                            <TryMap waypoints={Waypoints} />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-12 col-md-4 col-lg-3 mb-3">
                        <div className="card h-100" style={{ cursor: "auto"}}>
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h5 className="card-title m-0 me-2 ruta">Eventos</h5>
                                <div className="dropdown">
                                </div>
                            </div>
                            <div className="card-body p-0" style={{ overflow: "auto", maxHeight: 600 }}>
                                <div>
                                    {InitEvents && InitEvents.map(this.renderEvent)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-9 mb-3">
                        <div className="card">
                            <div className="d-flex align-items-end row">
                                <div className="col-sm-12">
                                    <div className="card-body" >
                                        <div className="h-100">
                                            <FullCalendarCmp
                                                initEvents={InitEvents}
                                                calendarFunctions={CalendarFunctions}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Dashboard